import { getGlobalStore } from '../../store/globalStore'

const requestInterceptor = config => {
	const accessToken = getGlobalStore().getState?.()?.core?.auth?.accessToken
	if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`
    config.headers['X-Auth-Token'] = `Bearer ${accessToken}`
  }
  return config
}

export default requestInterceptor
